// extracted by mini-css-extract-plugin
module.exports = {"comp":"AccordionVideo_comp__JxWLW"};